
var Helpers = require('../utils');
var Pins = require('./Pins');
var Filters = require('./Filters');
var debug = require('debug')('CRMMap:CRMMapEmbed');

var Drawing = require('../crmmap/Map/Drawing').Drawing;
var APIData = require('../crmmap/Data/Data').Data;


var Legend = require('../common/Legend').Legend;




debug(APIData);

class CRMMapEmbed {
	constructor(apihost, apikey, mapid) {
		debug('CRMMapEmbed Welcome');
		this.element = mapid?document.getElementById(mapid):null;
		this.apihost = apihost;
		this.apikey = apikey;
		this.center = { lat: -34.933333, lng: 138.6 };
		this.zoom = 10;
		this.map = null;
		this.pins = new Pins(this);
		this.logo = null;
		this.filters = new Filters(this);
		this.showHeatMap = false;
		this.statusids = false;
		this.showlegend = 0;
		this.poslegend = 8; // Magic number for RIGHT_CENTER;
		this.drawing = null;
		this.mapstyle = "";
		this.Data = null;

		this.mapoverlay = false;
		this.imageMapType = false;

		this.onClick = false;
		this.onPinsUpdated = false;
		this.readycallback = null;
		
		

	}

	setZoom(zoom) {
		debug('setZoom', zoom);
		zoom = parseInt(zoom);
		if (this.zoom == zoom) {
			return this;
		}

		this.zoom = zoom;
		if (this.map) {
			this.map.setZoom(zoom);
		}
		return this;
	}

	setCenter(newlat, newlng) {
		debug('setCenter', newlat, newlng);
		this.center = { lat: parseFloat(newlat), lng: parseFloat(newlng) };
		if (this.map) {
			this.map.setCenter(this.center);
		}
		return this;
	}

	setLegend(stage) {
		debug('setLegend',stage);
	this.Legend.setstage(stage);
	}


	init() {
		debug('Google Maps Init');
		this.updateMapSettings().then(() => {
			debug('init post updateMapSettings');
			if (typeof google !== 'undefined') {

				var mapOptions = {
					zoom: this.zoom,
					center: this.center,
					zoomControl: true,
					scaleControl: true,
				//	streetViewControl: false,
				//	mapTypeControl: false,
					rotateControl: true,

					mapTypeId: google.maps.MapTypeId.ROADMAP,
					styles: this.mapstyle,
					disableDefaultUI: true
				};

				debug(this.mapstyle);



				this.map = new google.maps.Map(this.element, mapOptions);

				var Logo = require('./Logo');
			//	var Legend = require('../common/Legend');

				this.logo = new Logo(this.element);
				this.logo.setMap(this.map);
		
		
				debug('Creating Legend...');
				
				this.Legend = new Legend((verb, callback, method, _data, raw) => {
					//wrapp to get normal Accede Maps Api call to work in embededededd
					//	apicall(what, params, raw = false)
					return this.apicall(verb, null, true);
				}, this.map, this.showlegend, false);
				this.Legend.setMapPos(this.poslegend);

				debug('Legend created');
				
				this.Data =  new APIData(this);
				this.drawing = new Drawing(this, this, this.map, true);

			
				this.setMapImage();			
			
		
			}


			if (!this.map) {
				console.error("FAILED: google maps did not load");
			}




			if (this.readycallback) {
				this.readycallback();
			}

			if (!this.readycallback) {

				this.updatePins();
			}
		});

	}

	setMapImage() {
		debug('setMapImage');
		if (this.mapoverlay && this.mapoverlay != 'false') {
			this.imageMapType = new google.maps.ImageMapType({
				getTileUrl: (tile,zoom) => {                      
					var ymax = 1 << zoom;	
					var y = ymax - tile.y -1;
					return this.mapoverlay+zoom+"/"+tile.x+"/"+y+".png";
					}
				});
				
				this.map.overlayMapTypes.setAt(5,this.imageMapType );

		} else {
			if (this.imageMapType) {
				this.map.overlayMapTypes.removeAt(5,this.imageMapType );
				this.imageMapType = null;
			}
		}
	
	}


	ready(callback) {
		debug("callback set");
		this.readycallback = callback;
	}

	updateMapSettings() {
		debug('updateMapSettings');
		return this.apicall('transactions/map/options', this.filters.all()).catch((error) => {
			console.error("serach error", error);
			this.crmmap.errordlg(error.statusText);    
	
			debug("ERROR: " + error.statusText);
			return false;
		}).then((options) => {
			debug('updateMapSettings >', options);
			if (options.zoom) {
				this.setZoom(options.zoom);
			}
			if (options.center) {
				debug('=-', options.center);
				if (!(options.center[0] == "" && options.center[1] == "")) {
					this.setCenter(options.center[0], options.center[1]);

				}
			}

			if (options.showarea) {
				this.pins.area_size = parseInt(options.showarea);
			}

			if (options.showicon) {
				this.pins.show_icon = parseInt(options.showicon) == 1;
			}

			if (options.showpin) {
				this.pins.show_pin = parseInt(options.showpin) == 1;
			}

			if (options.showheatmap) {
				this.showHeatMap = parseInt(options.showheatmap) == 1;
				this.updateHeatMap();
			}

			if (options.statusids) {
				this.statusids = options.statusids;
			}


			if (options.showlegend) {
				this.showlegend = options.showlegend;
			}

			if (options.mapoverlay) {
				this.mapoverlay = options.mapoverlay; 
			}

			if (options.poslegend) {
				this.poslegend = options.poslegend;
			
			}


		

			this.mapstyle = [
				{
					"featureType": "administrative.land_parcel",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fd9db6"
						},
						{
							"visibility": "on"
						},
						{
							"weight": 5.5
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "landscape.man_made",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "landscape.man_made",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#9bacff"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.business",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.government",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.medical",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				}
			];


			if (options.mapstyle) {
				this.setStyle(options.mapstyle);
			}

			return this;
		});
	}

	setStyle (style) {
		debug('setStyle', style);
			var ms = style;
		if (typeof ms === 'string' || ms instanceof String) {
			try {
				ms = JSON.parse(ms);
			} catch (error) {
				//if there is an error, don't change anything
				console.error("Map Style Error", error, style);
				ms = this.mapstyle;
			}
		}

		if (!(ms == null)) {
			this.mapstyle = ms;
			if (this.map) {
				this.map.setOptions({ styles: this.mapstyle });
			}
		}

	}

	updatePins() {
		debug('updatePins');
		return this.pins.markall().then(() => {

			this.apicall('transactions/map', this.filters.all()).catch((error) => {
				alert(error.statusText);
				debug("ERROR: " + error.statusText);
				return false;
			}).then((pins) => {
				if (!pins) {
					debug("No Pins found");
					return false;
				}

				debug('updatePins>', pins);
				var promises = pins.points.map((data) => {
					return new Promise((resolve) => {
						if (data['Geoboundaries']) {
							var pin = null;
							var pointIn = Helpers.parsePolyStrings(data['Geoboundaries'])[0][0];
							pin = this.pins.get(data['Id']).update(pointIn, data['Icons'], data['labeltext']);
							return resolve(pin);
						}
						//debug('No Geo for pin', data);
						return resolve(false);

					});
				});


				return Promise.all(promises).then(() => { return this.updateHeatMap() }).then(() => {
					return this.pins.deletemarked();

				}).then(()=>{
					if (this.onPinsUpdated) {
						this.onPinsUpdated();
					}
				})
			});
		});
	}



	updateHeatMap() {
		debug('updateHeatMap');
		return false;
		return this.pins.heatMapData().then((pinsarray) => {
			debug('updateHeatMap> ', pinsarray.length);
			if (pinsarray.length <= 0) { return this; }


			if (!this.heatmap) {
				this.heatmap = new google.maps.visualization.HeatmapLayer({
					data: pinsarray
				});
			}

			this.heatmap.setMap(this.showHeatMap ? this.map : null);
			return this;
		})

	}

//this is call from CRMMap Propper,
	APICall(verb, callback, method, _data, raw) {
		debug('APICall', verb, callback, method, _data, raw);
		return this.apicall(verb);
	}

	CRMMap() {
		debug('CRMMap');
		return this;
	}

	apicall(what, params, raw = false) {
		debug('apicall', what, params, raw);
		return new Promise((resolve, reject) => {
			var xmlhttp = new XMLHttpRequest();
			xmlhttp.onload = function () {
				var res = false;
				if (!raw) {
					try {
						res = JSON.parse(xmlhttp.responseText);
					} catch (e) {
						console.error("apicall", e);
         			    this.crmmap.errordlg(e);  
						console.log(xmlhttp.responseText);
					}

				} else {
					res = xmlhttp.responseText;
				}

				if (this.status >= 200 && this.status < 300) {
					return resolve(res);
				}


				if (res.error) {
					return reject({
						status: this.status,
						statusText: res.error
					});
				}
				return reject({
					status: this.status,
					statusText: xmlhttp.statusText
				});

			};
			xmlhttp.onerror = function (d) {
				debug('apicall Error', d);
				reject({
					status: this.status,
					statusText: xmlhttp.statusText
				});
			};

			var url = this.apihost;

			if (what) {
				url = url + '/' + what;
			}

			if (!params) {
				params = [];
			}

			params['apikey'] = this.apikey;

			url = url + "?" + Helpers.urlArray(params);

			xmlhttp.open("GET", url, true);
			xmlhttp.send();
		});

	}



}
module.exports = CRMMapEmbed;